import {
  MySubmission,
  RankedSubmission,
} from "@/api/generated/backendAPI.schemas";
import { useState } from "react";
import { submissionResultRetrieve } from "@/api/generated/backendAPI";
import { Link } from "@tanstack/react-router";
import {getShortenedScore} from "@/utils/utils"
import '../components.scss'

type Props = {
  mySubmissions: readonly MySubmission[] | undefined;
  rankedSubmission: readonly RankedSubmission[] | undefined;
  licenseId: string;
  submissionType?: string;
};

function Submissions({ mySubmissions, rankedSubmission, licenseId, submissionType }: Props) {
  const [waiting, setWaiting] = useState(false)
  // ボタンのクリックで表示非表示を切り替える

  const handleResultDataDownload = (submission_id : string | null = "", file_name = "results.json") => {
      setWaiting(true)
      if (!submission_id) {
        console.error("Submission ID is required for downloading results.");
        setWaiting(false)
        return;
      }
      submissionResultRetrieve(submission_id)
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = file_name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        })
        .finally(() => {
          setWaiting(false)
        });
    };
  if (!mySubmissions) {
    return <></>;
  }
  return (
    <div className="px-4 py-3 @container">
      <div className="flex overflow-hidden rounded-xl border border-[#dbe1e6] bg-white">
        <table className="flex-1">
          <thead>
            <tr className="bg-white">
              <th className="table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-176 px-4 py-3 text-center text-[#111518] w-[400px] text-sm font-medium leading-normal">
                投稿日時
              </th>
              <th className="table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-416 px-4 py-3 text-center text-[#111518] w-[400px] text-sm font-medium leading-normal">
                投稿ステータス
              </th>
              <th className="table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-536 px-4 py-3 text-center text-[#111518] w-[400px] text-sm font-medium leading-normal">
                スコア
              </th>
              <th className="table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-536 px-4 py-3 text-center text-[#111518] w-[300px] text-sm font-medium leading-normal">
                ランク
              </th>
              <th className="table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-656 px-4 py-3 text-center text-[#111518] w-[350px] text-sm font-medium leading-normal">
                投稿回数
              </th>
            </tr>
          </thead>
          <tbody>
            {mySubmissions.map((data) => {
              const bestSubmission = rankedSubmission
                ? rankedSubmission.find((s) => s.submissionId === data.id)
                : null;
              const status =
                data.status === "success"
                  ? "投稿完了"
                  : data.status.includes("error")
                    ? "投稿エラー"
                    : "処理中";
              const createdAt = data.createdAt
                ? new Date(data.createdAt)
                : null;
              return (
                <tr className="border-t border-t-[#dbe1e6]" key={data.id}>
                  <td className="flex items-center justify-center table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-176 h-[72px] px-4 py-2 w-full text-sm font-normal leading-normal gap-4">
                    {createdAt ? createdAt.toLocaleString() : ""}
                  </td>
                  <td className="table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-416 h-[72px] px-4 py-2 w-[400px]  text-sm font-normal leading-normal">
                    <div className={`flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-xl h-8 px-4 py-2 text-white text-sm font-bold w-full ${status === "投稿エラー" ? "bg-errcolor" : "bg-graycolor"}`}>
                      <span className="truncate">{status}</span>
                    </div>
                    {data.submissionNote && (
                      <p className="mx-auto my-2 text-xs max-w-[90%]" style={{ whiteSpace: 'pre-line' }}>{data.submissionNote}</p>
                    )}
                  </td>
                  <td className="text-center table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-416 h-[72px] px-4 py-2 w-[400px]  text-sm font-normal leading-normal">
                    <p className="score font-normal text-md text-black relative">
                      {data.score != null ? getShortenedScore(data.score) : ""}
                      <span className="hidden absolute hover:block">{data.score}</span>
                    </p>
                    {data.submissionResultFileSubmissionId && submissionType !== "pptx" && (
                      <button
                        onClick={() => handleResultDataDownload(data.submissionResultFileSubmissionId, `results_${data.id}.json`)}
                        className="mt-1 flex items-center justify-center text-xs border-none bg-transparent text-blue-600 hover:underline px-4 py-2"
                        disabled={waiting}
                      >
                        &gt; 結果詳細ダウンロード
                      </button>
                    )}
                  </td>
                  <td className="text-center table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-536 h-[72px] px-4 py-2 w-[400px] text-sm font-normal leading-normal">
                    <p>
                      {bestSubmission && (
                        <Link to="/competitions/$licenseId/score" params={{licenseId}}>
                          <span>No. {bestSubmission.rankNum}</span></Link>
                      )}
                    </p>
                  </td>
                  <td className="text-center table-bf633e47-f1d1-4381-9150-81b0cc4a3c61-column-656 h-[72px] px-4 py-2 w-[400px] text-sm font-normal leading-normal">
                    {data.mySubmissionCount}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Submissions;
